/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentSlotRepeater/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Repeater from 'DesignSystem/Repeater/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentSlotRepeater({
  children,
  viewPath = "/App/Form/Data/ReviewData/AppointmentSlotRepeater",
  text
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Repeater
  viewPath={`${viewPath}/Repeater`}
 label="Appointment Date And Time"
 onClick={() => setFlowTo("/App/Form/Data/ProvideData/AppointmentSlot")}
 isSelected={flow.has("/App/Form/Data/ProvideData/AppointmentSlot")}
 text={text}
 textTransform="none"
/>
{children}
</React.Fragment>)
}